import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { LoaderService } from 'src/app/shared/utils/loader.service';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { MFValidators } from 'src/app/shared/validators/mf-validators';
import { AccountSettingsService } from '../account-setting.service';
import { CommonService } from 'src/app/shared/utils/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { Utility } from 'src/app/shared/utils/utility.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { UserManagementService } from 'src/app/user-management/user-management.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-account-name-change',
  templateUrl: './account-name-change.component.html',
  styleUrls: ['./account-name-change.component.scss'],
})
export class AccountNameChangeComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Input() SuccessMessage!: string;
  @Output() stepperChange = new EventEmitter<number>();
  @Output() SuccessMessageChange = new EventEmitter<string>();
  readonly LANG_CONST = LANG_CONST;
  CONSTANTS = CONSTANTS;
  changeNameForm!: FormGroup;
  errorMessage: string = '';
  @Input() formGroupName!: string;
  existingFirstName: string = '';
  existingLastName: string = '';
  subscription: Subscription | undefined;
  groupName!: string;
  groupTypeId!: string;
  siteId!: string;
  get formInstance() {
    return this.changeNameForm?.controls;
  }

  constructor(
    private accountSettingService: AccountSettingsService,
    private notificationService: NotificationService,
    private rootFormGroup: FormGroupDirective,
    public commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private stateManagementService: StateManagementService,
    private userManagementService: UserManagementService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {}

  /**
   * @description this is onInit life cycle method
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.subscription = this.route.params.subscribe((params) => {
      this.groupName = Utility.decodeFromBase64(params['groupTypeName']);
      this.groupTypeId = Utility.decodeFromBase64(params['userGroupId']);
    });
    this.changeNameForm = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    this.existingFirstName = this.formInstance?.firstName.value;
    this.existingLastName = this.formInstance?.lastName.value;
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.changeNameForm.patchValue({
      firstName: this.existingFirstName,
      lastName: this.existingLastName,
    });
    this.stepperChange.emit((this.stepper = 1));
  }

  /**
   * @description ##updateName function trigger on update button and call the updateName API.
   * @returns void
   */
  updateName() {
    this.accountSettingService
      .updateName(
        this.formInstance?.firstName.value,
        this.formInstance?.lastName.value
      )
      .subscribe({
        next: (res: any) => {
          this.stateManagementService.updateUsersList([]);
          this.userManagementService.setTriggerRerender(true);
          if (res?.updateUser?.email) {
            this.SuccessMessageChange.emit(
              (this.SuccessMessage = this.translate.instant('NAME_UPDATED'))
            );
            this.stepperChange.emit((this.stepper = 5));
          }
          const currentUrl = this.router.url;
          if (currentUrl.includes(CONSTANTS.USER_DASHBOARD)) {
            const encodedGroupName = Utility.encodeToBase64(this.groupName);
            const encodedGroupTypeId = Utility.encodeToBase64(this.groupTypeId);
            this.router.navigate([
              `${CONSTANTS.USER_DASHBOARD}${encodedGroupName}/${encodedGroupTypeId}`,
            ]);
          } else if (currentUrl.includes(CONSTANTS.DASHBOARD_URL)) {
            this.router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                if (window.__dev__) this.router.navigateByUrl(currentUrl);
              });
          } else if (currentUrl.includes(CONSTANTS.USERS)) {
            this.router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                if (window.__dev__) this.router.navigateByUrl(currentUrl);
              });
          } else if (currentUrl.includes(CONSTANTS.SITE_MANAGEMENT)) {
            this.router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                if (window.__dev__) this.router.navigateByUrl(currentUrl);
              });
          }
        },
        error: (err: Error) => {
          this.notificationService.showError(err?.message);
        },
      });
  }
}
